import React, { FC, useState } from "react";
import {
  StyleSheet,
  TextInput,
  TextInputProps,
  View,
  Text,
  Pressable,
} from "react-native";

import { EyeOff, EyeShow } from "../../../assets/index";

interface InputProps extends TextInputProps {
  type?: "default" | "email-address" | "numeric" | "phone-pad";
  name: string;
  placeholder?: string;
  required?: boolean;
  focusBackgroundColor?: string;
  focusBorderColor?: string;
}

const Input: FC<InputProps> = ({
  type = "default",
  name,
  placeholder = "",
  value,
  onChangeText,
  onFocus,
  onBlur,
  secureTextEntry = false,
  required = false,
  focusBackgroundColor,
  focusBorderColor,
  ...otherProps
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <View style={styles.container}>
      {name && (
        <Text style={styles.text}>
          {name} {required && <Text style={styles.colorRed}>*</Text>}
        </Text>
      )}
      <TextInput
        style={[
          styles.input,
          isFocused && focusBackgroundColor
            ? { backgroundColor: focusBackgroundColor }
            : null,
          isFocused && focusBorderColor
            ? { borderColor: focusBorderColor }
            : null,
        ]}
        keyboardType={type}
        placeholder={placeholder}
        value={value}
        onChangeText={onChangeText}
        secureTextEntry={secureTextEntry && !showPassword}
        onFocus={(event) => {
          setIsFocused(true);
          onFocus?.(event);
        }}
        onBlur={(event) => {
          setIsFocused(false);
          onBlur?.(event);
        }}
        {...otherProps}
      />
      {secureTextEntry && (
        <Pressable
          style={styles.togglePassword}
          onPress={togglePasswordVisibility}
          // @ts-ignore comment
          tabIndex={-1}
        >
          {!showPassword && <EyeOff />}
          {showPassword && <EyeShow />}
        </Pressable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
  },
  text: {
    fontFamily: "Urbanist400",
    fontSize: 18,
    fontStyle: "normal",
    lineHeight: 18 * 1.4,
    paddingVertical: 12,
    color: "#282B33",
  },
  input: {
    height: 48,
    width: "100%",
    fontFamily: "Urbanist500",
    lineHeight: 16 * 1.4,
    fontSize: 16,
    letterSpacing: 0.032,
    color: "#868B97",
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderColor: "#C4C6CD",
    borderWidth: 1,
    borderRadius: 10,
  },
  togglePassword: {
    position: "absolute",
    bottom: 11,
    right: 16,
  },
  colorRed: {
    color: "red",
  },
});

export default Input;
